function filterEvents() {
    let $width = $(window).width();
    let scrollHandler = false;

    function hideOnScroll(target, tester, trigger){
        if($(tester).hasClass('is-stuck') && $(target).hasClass('is-open')){
            $(target).slideUp().removeClass('is-open');
            $(trigger).removeClass('is-active');
        }
    }

    function resetFilter(target, trigger) {
        $('b2t').show();
        $('.js-filter-dropdown').show().removeClass('is-active');
    }
    
    if ($width <= 960 && !scrollHandler){
        $(window).on('scroll', function(){
            hideOnScroll('.js-filter-dropdown', '.services-filter', '.js-filter-trigger');
        });
        scrollHandler = true;
    } else {
        resetFilter('.js-filter-dropdown');
        scrollHandler = false;
    }
}

export default {
    initFilter : filterEvents
}